import { MessageCircle } from "lucide-react";
import WhatsApp from "@/components/ui/WhatsApp";

import content from "@/content/cta.json";

interface Data {
  title: string;
  subtitle: string;
}

const data: Data = content;

const Cta = () => {
  return (
    <section id="Contato" className="py-20 lg:py-28">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="border-border from-secondary to-background relative overflow-hidden rounded-3xl border bg-linear-to-br px-6 py-16 text-center sm:px-12 lg:py-20">
          <div className="bg-primary/10 absolute -top-24 -right-24 h-64 w-64 rounded-full blur-3xl" />
          <div className="bg-accent/10 absolute -bottom-24 -left-24 h-64 w-64 rounded-full blur-3xl" />
          <div className="relative">
            <h2 className="font-display text-foreground text-4xl tracking-wide sm:text-5xl lg:text-6xl">
              {data.title}
            </h2>
            <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
              {data.subtitle}
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <WhatsApp className="group bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/25 inline-flex items-center gap-2 rounded-full px-8 py-4 text-base font-semibold transition-all hover:shadow-xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
